import {
  Component,
  EventEmitter,
  HostBinding,
  HostListener,
  Input,
  Output,
  ChangeDetectionStrategy
} from "@angular/core";
import { ButtonOutput } from "../button/button-output";
import { ButtonActionsType } from "../button/button-actions.type";

@Component({
    selector: "app-profile-icon",
    templateUrl: "./profile-icon.component.html",
    styleUrls: ["./profile-icon.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ProfileIconComponent {
  /**
   * Initials that should be displayed on the profile indicator
   */
  @Input() initials = "";

  /** Aus: reine Anzeige, ohne Fokus, Hover und Klick. */
  @Input() clickable = true;

  @HostBinding("class") get hostClasses() {
    const classList = ["profile-icon"];
    if (!this.clickable) {
      classList.push("profile-icon--static");
    }
    return classList;
  }

  @HostBinding("attr.tabindex") get tabindex() {
    return this.clickable ? "0" : null;
  }

  /**
   * main button output
   */
  @Output() action: EventEmitter<ButtonOutput> =
    new EventEmitter<ButtonOutput>();

  @HostListener("click", ["$event"])
  public click(evt: Event) {
    if (!this.clickable) {
      return;
    }

    this.action.emit({
      type: ButtonActionsType.Click,
    });
  }
}
